import createModelStore from "../../utils/createModelStore";
import Dispatcher from "../../services/Dispatcher";

const dispatchers = createModelStore<Dispatcher.Model, "dispatchers">(
	"dispatchers",
);

export default dispatchers;
